module.exports = __webpack_public_path__ + "86bf06f13be9db75ac16da38f1397147.fbx";